import React from 'react';
import Slick, { Settings } from 'react-slick';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

export interface SliderProps extends Settings { }

const settings = {
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        // infinite: true,

      },
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const NextArrow: React.FC<any> = ({ className, onClick }) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(className, classes.arrow, classes.nextArrow)}
      onClick={onClick}
    />
  );
};

const PrevArrow: React.FC<any> = ({ className, onClick }) => {
  const classes = useStyles();
  return (
    <div
      className={clsx(className, classes.arrow, classes.prevArrow)}
      onClick={onClick}
    />
  );
};

const Slider: React.FC<SliderProps> = (props) => {
  return (
    <Slick
      {...settings}
      nextArrow={<NextArrow />}
      prevArrow={<PrevArrow />}
      {...props}
    />
  );
};

const useStyles = createUseStyles({
  arrow: {
    position: 'absolute',
    transform: 'none',
    width: '50px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    top: '0',
    bottom: '0',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    zIndex: '10',
  },
  nextArrow: {
    right: '0px',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
  },
  prevArrow: {
    left: '0px',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
  },
});

export default Slider;
